import { useContext } from "react";
import { useNode } from "@craftjs/core";
import Map, { MAPTYPE, Marker } from "@/components/map/Map";
import MapBlockSettings from "@/components/editor/settings/MapSettings/MapBlockSettings";
import { CssClass } from "@/components/editor/settings/ClassSettings";
import useResponsiveValues from "../hooks/useResponsiveValues";
import { OrganizationProvider } from "@/features/websites/components/OrganizationProvider";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";
import useNormalizeDimentions from "../settings/DimentionSettings/useNormalizeDimentions";
import { MapProps } from "../settings/MapSettings/MapSettings";
import { DimentionProps } from "../settings/DimentionSettings/types";

interface Props extends DimentionProps, CssClass, MapProps {}

const MapBlock = (props: Props) => {
  const responsive = useResponsiveValues();
  const dimentions = useNormalizeDimentions(props);
  const providerOrganization = useContext(OrganizationProvider);
  const websiteOrganization = useContext(WebsiteContext);
  const organization = websiteOrganization.organization ?? providerOrganization;

  const {
    connectors: { connect, drag },
  } = useNode((state) => {
    return {
      hasSelectedNode: state.events.selected,
      hasDraggedNode: state.events.dragged,
    };
  });

  return (
    <div ref={(ref: any) => connect(drag(ref))} className={`map-section ${responsive.getValue(props?.cssClass)}`}>
      <Map
        width={dimentions.width as string}
        height={dimentions.height as string}
        defaultCenter={{
          lat: props?.latitude ?? organization?.latitude ?? "",
          lng: props?.longitude ?? organization?.longitude ?? "",
        }}
        type={props?.type as MAPTYPE}
        defaultZoom={14}
      >
        <Marker lat={props?.latitude ?? organization?.latitude ?? ""} lng={props?.longitude ?? organization?.longitude ?? ""} />
      </Map>
    </div>
  );
};

MapBlock.craft = {
  displayName: "Ubicación",
  related: {
    settings: MapBlockSettings,
  },
};

export default MapBlock;
